import { ShadowRealm } from "~/src/customElements/shadowRealm"

ShadowRealm.define()
